<template>
    <div>
        <div class="row">
            <div class="col-md-12 form-group" v-if="resultItem.isCompleted">
                <div class="result-icon" v-if="resultItem.isApproved">
                    <span class="text-success fa fa-thumbs-up fa-2x"></span>
                    {{$t('coordinations.approved')}}
                </div>
                <div class="result-icon" v-if="!resultItem.isApproved">
                    <span class="text-danger fa fa-thumbs-down fa-2x"></span>
                    {{$t('coordinations.rejected')}}
                </div>
            </div>
            <div class="col-md-12 form-group" v-if="!resultItem.isCompleted">
                <div class="result-icon">
                    <i class="text-primary fa fa-sync fa-2x fa-spin"></i>
                    {{$t('coordinations.ongoing')}}
                </div>
            </div>
            <div class="col-md-12">
                <div class="list-item" v-for="(item, index) in resultItem.answers" :key="'answers'+index">
                    <span class="text-success fa fa-thumbs-up" v-if="item.isApproved"></span>
                    <span class="text-danger fa fa-thumbs-down" v-if="!item.isApproved"></span>
                    {{item.userName}} - {{$moment(item.createdOn).format('DD MMM YYYY HH:mm')}}
                    <div>
                        <strong>{{$t('coordinations.comment')}}:</strong>
                        {{item.comment}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import coordinationsService from '@/services/coordinations.service';

    export default {
        components: {},
        props: {
            taskId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                resultItem: {}
            };
        },
        methods: {
            async loadData() {
                try {
                    var result = await coordinationsService.getResult(this.taskId);
                    this.resultItem = { ...result.data };
                } catch (err) {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                }
            }
        },
        mounted() {
            this.loadData();
        }
    };
</script>

<style lang="scss" scoped>
    .result-item {
        border-bottom: 1px solid lightgrey;
    }

    .fa-2x {
        text-align: center;
        border: 2px solid #4caf50;
        border-radius: 50%;
        padding: 15px;
    }

        .fa-2x.text-danger {
            border-color: #f44336 !important;
        }

        .fa-2x.text-primary {
            border: none !important;
        }

    .result-icon {
        display: flex;
        flex-direction: column;
        width: fit-content;
        margin: 0 auto;
    }

    .list-item {
        border-bottom: 1px solid lightgrey;
        padding-bottom: 5px;
    }
</style>
